<template>
    <div v-show="active">
        <slot> </slot>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        icon: String,
        startActive: false
    },
    data: function(){
        return {
            active: false
        }
    },
    beforeMount(){
        if(this.startActive == true){
            this.active = true;
        }
    }
}
</script>